export const lightMode = {
  100: "#FFFFFF",
  200: "#EDF2F7",
  300: "#eeeff2",
};

export const darkMode = {
  100: "#0F3457",
  200: "#1E293B",
  300: "#0F172A",
};

export const sidebar = {
  light: "#084678",
  dark: darkMode[300],
};
